import { Security } from "@okta/okta-react";
import { useNavigate, Outlet } from "react-router-dom";
import { oktaAuth } from "./oktaConfig";
import { TokenSync } from "./TokenSync";
import { getSafePostAuthPath } from "./oktaUtils";

export function AuthRootLayout() {
  const navigate = useNavigate();

  const restoreOriginalUri = (_: unknown, originalUri: string) => {
    navigate(getSafePostAuthPath(originalUri), { replace: true });
  };

  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      <TokenSync />
      <Outlet />
    </Security>
  );
}
